/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailsTeam
 */
export interface UserDetailsTeam {
    /**
     * 
     * @type {string}
     * @memberof UserDetailsTeam
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsTeam
     */
    name: string;
}

/**
 * Check if a given object implements the UserDetailsTeam interface.
 */
export function instanceOfUserDetailsTeam(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UserDetailsTeamFromJSON(json: any): UserDetailsTeam {
    return UserDetailsTeamFromJSONTyped(json, false);
}

export function UserDetailsTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailsTeam {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function UserDetailsTeamToJSON(value?: UserDetailsTeam | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

